import { useState } from "react";

import "./Button.css";
import { PathologyWatchButton, PathologyWatchButtonProps } from "./Button";

type ToggleButtonProps = Partial<PathologyWatchButtonProps> & {
  colors?: {
    on?: "red" | "green" | "grey" | "yellow" | "blue";
    off?: "red" | "green" | "grey" | "yellow" | "blue";
  };
};

type ControlledToggleButtonProps = ToggleButtonProps & {
  isToggled: boolean;
};

export const ControlledToggleButton = (props: ControlledToggleButtonProps) => {
  const { title, id, onClick, isToggled, colors, disabled, children, type } =
    props;

  const handleOnClick = (e: any) => {
    onClick && onClick(e);
  };

  return (
    <PathologyWatchButton
      title={title || ""}
      id={id}
      type={type}
      onClick={handleOnClick}
      disabled={disabled}
      color={isToggled ? colors?.on || "green" : colors?.off || "grey"}
    >
      {children}
    </PathologyWatchButton>
  );
};

export const ToggleButton = (props: ToggleButtonProps) => {
  const { title, id, onClick, colors, disabled, children } = props;
  const [toggle, setToggle] = useState<boolean>(false);

  const handleOnClick = (e: any) => {
    setToggle(!toggle);
    onClick && onClick(e);
  };

  return (
    <PathologyWatchButton
      title={title || ""}
      id={id}
      onClick={handleOnClick}
      disabled={disabled}
      color={toggle ? colors?.on || "green" : colors?.off || "grey"}
    >
      {children}
    </PathologyWatchButton>
  );
};

export const UnderlineToggleButton = (
  props: Partial<ControlledToggleButtonProps>
) => {
  const { title, id, onClick, isToggled, disabled, children } = props;

  const handleOnClick = (e: any) => {
    onClick && onClick(e);
  };

  return (
    <PathologyWatchButton
      title={title || ""}
      id={id}
      onClick={handleOnClick}
      disabled={disabled}
      className={
        isToggled
          ? "pwButton--underline pwButton--underline--active"
          : "pwButton--underline"
      }
    >
      {children}
    </PathologyWatchButton>
  );
};

export default ToggleButton;
